import {AfterViewInit, Component, Inject, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {Subscription} from "rxjs";
import {ToastService} from "maps-angular-components";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CadastroRegraComponent} from "../../regra/cadastro-regra/cadastro-regra.component";
import {ComponentSelectorService} from "./component-selector.service";
import {DetalheModel} from "./detalhe-model";
import * as EventEmitter from 'events';
import {AssociacaoGerenciadorComponent} from "../../associacao/associacao-gerenciador/associacao-gerenciador/associacao-gerenciador.component";
import {ModalAssociacaoComponent} from "./modal-associacao/modal-associacao.component";

@Component({
    selector: 'app-modal-feito-conferido-detalhe',
    templateUrl: './modal-detalhe-alteracoes.component.html',
    styleUrls: ['./modal-detalhe-alteracoes.component.scss']
})
export class ModalDetalheAlteracoesComponent
    implements AfterViewInit, OnDestroy {

    private readonly subscriptions = new Subscription();

    private readonly messageService: ToastService;

    @ViewChild("details", {static: true, read: ViewContainerRef})
    private readonly detailsView: ViewContainerRef;

    private component: any;

    onComplete = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DetalheModel,
        messageService: ToastService,
        public dialogRef: MatDialogRef<ModalDetalheAlteracoesComponent>,
        private readonly componentSelectorService: ComponentSelectorService
    ) {
        this.messageService = messageService;
    }

    ngOnInit(): void {
        this.component = this.componentSelectorService.loadComponent(this.detailsView, this.data.entryType).instance;
        if (this.component instanceof ModalAssociacaoComponent) {
            this.initilizeComponent();
        }
    }

    ngAfterViewInit() {
        this.initilizeComponent();
    }

    initilizeComponent() {
        if (this.component instanceof CadastroRegraComponent) {
            this.component.isConsulta = true;
            this.component.isDiolog = true;
            this.component.regra = this.data.entityModel;
            this.component.ngOnInit();
            //this.component.popularRegra(this.data.entityModel);
        } else {
            this.component.data = this.data.entityModel;
            this.component.ngOnInit();
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
